const POSTHOG_API_KEY = atob('cGhjX25KcnFHbUw3aW9YMklWQ1ZvRUZy') +
    atob('UW12WThMR0tkU01wVHpKQU9VeEhld2I0');
const POSTHOG_PAGE = 'channel';
export const postHogConfig = {
    apiKey: POSTHOG_API_KEY,
    host: `${window.location.protocol}//${window.location.host}/${POSTHOG_PAGE}`,
    debug: false,
    options: {
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: false,
        capture_performance: {
            web_vitals_allowed_metrics: ['LCP', 'CLS', 'FCP', 'INP'],
        },
        request_batching: false,
        disable_compression: true,
        advanced_disable_flags: true,
        disable_external_dependency_loading: false,
        disable_session_recording: true,
        disable_surveys_automatic_display: true,
        disable_surveys: true,
        disable_web_experiments: true,
    },
};
